import { KeycloakUtil } from "@/utils/keycloak";
import StorageService from "@/services/StorageService";
import i18n from "@/i18n";
import { store } from "../store";

const storageService = new StorageService();

export async function handleUnauthorizedError(
  keycloak: KeycloakUtil,
  errorTitle: string,
  errorDetail: string
) {
  // Removes the user instance from the local storage
  storageService.delete("user");
  storageService.delete("token");

  // Sets the i18n language to match the browser language
  i18n.global.locale = navigator.language;

  if (keycloak && await keycloak.isAuthenticated()) {
    let params;
    if (errorTitle && errorDetail) {
      params = `?error_title=${errorTitle}&error_detail=${errorDetail}`;
    }

    if (params) {
      await keycloak.logout(params);
    } else {
      await keycloak.logout();
    }
  } else {
    store.commit("open", {
      type: "danger",
      title: i18n.global.t("LOGIN.INVALID_SESSION_TITLE"),
      text: i18n.global.t("LOGIN.INVALID_SESSION_DETAIL")
    });
  }
}
